import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-sample-material-icon',
    templateUrl: './sample-material-icon.component.html',
    styleUrls: ['./sample-material-icon.component.scss'],
    standalone: false
})
export class SampleMaterialIconComponent implements OnInit {

  @Input() iconName: string;
  @Input() colorWhite: boolean;

  constructor() { }

  ngOnInit() {
  }

}
